<template>
  <div class="printme">
    <div class="visibility-hidden">
      <b-row>
        <b-col cols="4">
          <img
            src="../../assets/logo-promart.png"
            style="height: 80px; width: auto"
            alt=""
          />
        </b-col>
        <b-col cols="4">
          <p class="font-weight-500" style="margin-bottom: 0; margin-top: 8%">
             INFORME TÉCNICO
          </p>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col cols="6">
        <b-form-group id="input-group-17" label="Cliente" label-for="input-17">
           <b-form-input
            
            id="input-17"
            v-model="informTech.clientName"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
       <b-form-group id="input-group-19" label="Tienda" label-for="input-19">
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.codeStore"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group id="input-group-19" label="N° OS" label-for="input-19">
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.numberOs"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
       <b-form-group
          id="input-group-19"
          label="Fecha de Servicio"
          label-for="input-19"
        >
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.dateService"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row >
      <b-col cols="6">
         <label>Reporte de cliente</label>
            <p>{{informTech.report}}</p>
      
      </b-col>
      <b-col cols="6">
        <label>Informe</label>
         <p>{{informTech.technicalReport}}</p>
        
      </b-col>
    </b-row>
 
    <b-row >
      <b-col md="12" class="padding-two-bottom">
        <label>Recomendaciones</label>
        <p>{{informTech.recommendations}}</p>
        
      </b-col>
    </b-row>
  

  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import { getPhotosRoute } from "../../assets/js/common";
export default {
  name: "ImpresionInformeVi",
  data() {
    return {
      photosRoute: [],
      slide: 0,
      sliding: null,
      currentPage: 1,
      perPage: 10,
      selectedOption: null,
      options: [
        { value: "MANIPULACION_CLIENTE", text: "MANIPULACION_CLIENTE" },
        { value: "PRODUCTO", text: "FALLA DE PRODUCTO" },
        { value: "MALA_INSTALACION", text: "MALA_INSTALACION" },
      ],
      fieldMaterial: [
        { key: "sku", label: "Sku" },
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        { key: "typeProduct", label: "Tipo" },
        { key: "actions", label: "" },
      ],
      skuService: "",
      skuServiceDes: "",
      quantitySku: "",
      reportClient: "",
      inform: "",
      recomendation: "",
      informTech: {
        codeStore: "",
        dniClient: "",
        dniTechnical: "",
        numOs: "",
        observationsArea: "",
        detailServices: "",
        observationsAdditional: "",
        dateService: "",
        id: "",
        serviceMaterial: [],
        specialJob: [],
        diagnostic:null
      }
    };
  },

  props: {
    idInspectionReport: {
      type: Number,
    },
  },
  created() {
    this.getInformTech();
  },
  computed: {
    ...mapState("module", ["username", "perfil","token"]),

  },
  methods: {
    
    print() {
      window.print();
    },
    
   async getInformTech() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ORDERS_CORE_BASE +
            "/ivr/" +
            this.idInspectionReport
        );
        this.informTech = response.data;
        console.log(response.data.idRoute);
       this.photosRoute= await getPhotosRoute(response.data.idRoute);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.font-bolder {
  font-weight: bold;
  font-size: 23px;
  padding: 0;
  background: transparent;
  border-color: transparent;
}
::v-deep .b-table thead {
  background: rgb(254, 123, 1);
  color: black !important;
  font-weight: 400 !important;
}
::v-deep .b-table thead th {
  font-weight: 400 !important;
}

</style>
